<template>
  <div class="modal__wrapper_category">
    <div class="modal__container_category custom-width">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.change category") }}</h4>
        <div class="cursor-pointer" @click.prevent="closeCategoryModal()">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group row my-lg-2">
            <div class="d-flex justify-content-center">
              <div class="col-lg-10 pl-0 pr-1">
                <select class="form-control" @change="onCategoryChange($event)">
                  <option v-for="cat in categories" :key="cat.id" :value="cat.id"
                    :selected="cat.formCategory === selectedCategory">
                    {{ cat.formCategory }}
                  </option>
                </select>
              </div>
              <div class="col-lg-2 px-0">
                <button class="save_btn py-1 w-100" @click.prevent="chageCategory()">
                  <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>{{ $t("navigations.save") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script src="./ChangeCategory.js"></script>
<style scoped>
.modal__wrapper_category {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.modal__container_category {
  position: fixed;
  border-radius: 4px;
  width: min(500px, 90%);
  background: #fff;
  overflow-x: hidden;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
}

.important {
  color: rgb(255, 0, 0);
}
</style>